import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import toast from 'react-hot-toast';
import Modal from 'react-modal';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { add_to_store } from '../../../redux/actions/storeActions';

const PushToStoreModal = ({ isModalOpen, closeModal, item }) => {
    const dispatch = useDispatch();
    const addToStore = () => {
        toast.promise(
            dispatch(add_to_store({ sku: item.sku })),
            {
                loading: 'Adding to store...',
                success: <b>Item added to store</b>,
                error: <b>Could not add item.</b>,
            },
            { position: 'top-right' },
        );
    };

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={() => closeModal()}
            className="Modal"
            overlayClassName="Overlay">
            <Container>
                <Heading as="h4" textAlign="center" fontSize="24px" mt="25px">
                    Push to Store Front{' '}
                </Heading>
                <Text fontSize="16px" textAlign="center" mt="25px">
                    Are you sure want Move this Product to Store front{' '}
                </Text>
                <VStack mt="20px">
                    <Button
                        w="100%"
                        color="#F5F5F5"
                        bg="#1b3b5f"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        h="48px"
                        outline="none"
                        onClick={() => {
                            addToStore();
                            closeModal();
                        }}>
                        Confirm
                    </Button>
                    <Button
                        w="100%"
                        color="#202325"
                        bg="white"
                        mt="15px"
                        fontWeight="400"
                        borderRadius="48px"
                        outline="none"
                        onClick={() => closeModal()}>
                        Cancel
                    </Button>
                </VStack>
            </Container>
        </Modal>
    );
};

export default PushToStoreModal;
const Container = styled.div`
    width: 380px;
    max-height: 100%;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    padding: 24px 24px;
    padding-bottom: 50px;

    @media screen and (max-width: 500px) {
        padding: 18px 18px;
        width: 100vw;
        max-height: 100%;
        background: #ffffff;
        border-radius: 16px 16px 0px 0px;
    }
    a {
        width: 95%;
        border-radius: 5px;
        padding: 4px;
        height: 44px;
        font-size: 20px;
    }
    .active-link {
        background: rgba(33, 33, 241, 0.1);
        color: #1b3b5f;
        font-weight: 700;
        svg {
            path {
                stroke: #1b3b5f;
            }
        }
    }
`;
